import React from 'react';

import { ChartsReferenceLine, LineChart } from '@mui/x-charts';
import { useYScale, useDrawingArea } from '@mui/x-charts/hooks';

interface Props {
  chartData: any;
}

interface DataSet {
  [key: string]: number[];
}

const colors = ['Limegreen', 'Red', 'DodgerBlue', 'Orange', 'Salmon'];

type ColorSwichProps = {
  color1: string;
  color2: string;
  id: string;
};

const AttackChartMUI: React.FC<Props> = ({ chartData }) => {
  const dataSetX: string[] = [];
  const dataSetY: DataSet = {};
  const kingdomLocations: string[] = chartData.map((x: any) => x.kingdomRef);

  function ColorSwitch({ color1, color2, id }: ColorSwichProps) {
    const { top, height, bottom } = useDrawingArea();
    const svgHeight = top + bottom + height;

    return (
      <defs>
        <linearGradient
          id={id}
          x1='0'
          x2='0'
          y1='0'
          y2={`${svgHeight}px`}
          gradientUnits='userSpaceOnUse' // Use the SVG coordinate instead of the component ones.
        >
          <stop offset='0%' stopColor={color1} stopOpacity={1} />
          <stop offset='49%' stopColor={color1} stopOpacity={0.1} />
          <stop offset='49%' stopColor={color2} stopOpacity={0.2} />
          <stop offset='100%' stopColor={color2} stopOpacity={1} />
        </linearGradient>
      </defs>
    );
  }

  dataSetY[chartData[0].kingdomRef] = [];
  for (let dataIndex = 1; dataIndex < chartData.length; dataIndex++) {
    dataSetY[chartData[dataIndex].kingdomRef] = [];
  }
  for (let tick = 0; tick < chartData[0].landChangedByDate.length; tick++) {
    dataSetX.push(chartData[0].landChangedByDate[tick].fullDateString);
    dataSetY[chartData[0].kingdomRef].push(
      chartData[0].landChangedByDate[tick].runningTotal
    );
    for (let dataIndex = 1; dataIndex < chartData.length; dataIndex++) {
      dataSetY[chartData[dataIndex].kingdomRef].push(
        chartData[dataIndex].landChangedByDate[tick].runningTotal
      );
    }
  }

  return (
    <LineChart
      height={400}
      margin={{ top: 20, bottom: 30, left: 40, right: 0 }}
      series={kingdomLocations.map((k, i) => {
        return {
          data: dataSetY[chartData[i].kingdomRef],
          label: k,
          area: true,
          showMark: false,
          color: colors[i],
          curve: 'natural',
        };
      })}
      xAxis={[{ scaleType: 'point', data: dataSetX }]}
      sx={{
        '& .MuiAreaElement-root': {
          fill: 'url(#swich-color-id-1)',
        },
      }}
    >
      {kingdomLocations.length === 2 && (
        <ColorSwitch
          color1='#11B678' // green
          color2='#FF3143' // red
          id='swich-color-id-1'
        />
      )}
      <ChartsReferenceLine
        y={0}
        lineStyle={{ stroke: 'white', opacity: 0.2 }}
      />
    </LineChart>
  );
};
export default AttackChartMUI;
